import React, { useState } from 'react';
import { X, Video, PlayCircle } from 'lucide-react';

const TutorialVideoModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    // Use CDN URL if configured, otherwise use local public folder
    const cdnUrl = process.env.REACT_APP_CDN_URL || '';
    const videoUrl = cdnUrl ? `${cdnUrl}/videos/platform-tutorial.mp4` : '/videos/platform-tutorial.mp4';
    const posterUrl = cdnUrl ? `${cdnUrl}/videos/platform-tutorial-poster.jpg` : '/videos/platform-tutorial-poster.jpg';

    return (
        <>
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black bg-opacity-50 z-[60] transition-opacity"
                onClick={onClose}
                aria-hidden="true"
            />

            {/* Modal */}
            <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
                <div
                    className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
                    onClick={(e) => e.stopPropagation()}
                >
                    {/* Header */}
                    <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-blue-100 dark:bg-blue-900 rounded-lg">
                                <Video className="w-6 h-6 text-blue-600 dark:text-blue-400" />
                            </div>
                            <div>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                                    How to Use Our Platform
                                </h2>
                                <p className="text-sm text-gray-600 dark:text-gray-400">
                                    6-minute tutorial to get you started
                                </p>
                            </div>
                        </div>
                        <button
                            onClick={onClose}
                            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full transition-colors"
                            aria-label="Close modal"
                        >
                            <X className="w-6 h-6 text-gray-600 dark:text-gray-400" />
                        </button>
                    </div>

                    {/* Video Content */}
                    <div className="p-6">
                        <div className="relative bg-gray-900 rounded-lg overflow-hidden shadow-lg">
                            <video
                                className="w-full aspect-video"
                                controls
                                controlsList="nodownload"
                                preload="metadata"
                                poster={posterUrl}
                            >
                                <source src={videoUrl} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>

                        {/* Video Description */}
                        <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                            <h3 className="font-semibold text-gray-900 dark:text-white mb-3">
                                What you'll learn:
                            </h3>
                            <ul className="space-y-2 text-sm text-gray-700 dark:text-gray-300">
                                <li className="flex items-start">
                                    <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                                    <span>How to search and filter tenders effectively</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                                    <span>Managing your favorite tenders and notifications</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                                    <span>Exporting data and using advanced features</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 dark:text-blue-400 mr-2">•</span>
                                    <span>Tracking contract awards and analytics</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TutorialVideoModal;
